import { ThemeOptions } from '@mui/material/styles'

export const lightTheme: ThemeOptions = {
  palette: {
    mode: 'light',
    background: {
      paper: '#f6f8fa',
      default: '#ffffff',
    },
    text: {
      primary: '#000000',
      secondary: '#1F2328',
    },
  },
}
